module.exports = __webpack_public_path__ + "img/22.d94df713.jpg";